module.exports = __webpack_public_path__ + "media/wherewework.c2b1b696.webm";